import type { JSX } from "react";

interface MainTitleProps {
  label?: string;
  title?: string | JSX.Element;
  description?: string;
  border?: boolean;
  fieldBindings?: {
    label?: string;
    title?: string;
    description?: string;
  };
}

export const MainTitle = ({
  label = "Getting Started",
  title = "Feel Like Yourself Again ",
  description = "Learn about our specialized massage therapy how it can help",
  border = true,
  fieldBindings,
}: MainTitleProps) => (
  <div className="max-w-7xl m-auto text-left text-gray-900 dark:text-gray-200 px-8">
    <div className="relative mt-6 text-left">
      {label && (
        <div
          className="mb-3 text-sm/6 font-semibold text-primary dark:text-primary-lighter flex items-center gap-1.5 headline"
          data-tina-field={fieldBindings?.label}
        >
          {label}
        </div>
      )}
    </div>
    <div className="flex flex-col lg:flex-row items-start gap-6">
      <div className="flex-1">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between">
          <h1
            className="text-3xl sm:text-4xl font-bold text-primary-darker-text
             dark:text-white tracking-tight title"
            data-tina-field={fieldBindings?.title}
          >
            {title}
          </h1>
        </div>
        <div
          className="mt-4 text-lg text-gray-500 dark:text-gray-400 text-left"
          data-tina-field={fieldBindings?.description}
        >
          {description}
        </div>
      </div>
    </div>
    {border && <div className="border-b border-gray-200 dark:border-gray-800 my-4 " />}
    {!border && <div className=" my-4 " />}
  </div>
);
export default MainTitle;
